import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ScrollRestoration from '@/components/feature/ScrollRestoration';

export default function Layout() {
  return (
    <>
      <ScrollRestoration />
      <Navbar />
      <main className="min-h-screen pt-16">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}